var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSidebarWhiteCLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 32,
    viewBox: "0 0 36 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7637 18.8267C11.7636 15.9628 13.4648 13.3738 16.0901 12.2427C18.7154 11.1117 21.7605 11.6557 23.8341 13.6263L23.8256 13.629C24.1754 13.9617 24.3155 14.4595 24.1908 14.9264C24.066 15.3932 23.6964 15.7542 23.2275 15.8671C22.7586 15.9801 22.4303 15.8671 21.9429 15.4677C20.1264 13.82 17.3304 13.9239 15.6407 15.702C13.9509 17.48 13.9834 20.2839 15.7139 22.0222C17.4443 23.7604 20.2419 23.7993 22.0198 22.1098C22.2527 21.8885 22.5514 21.7772 22.9275 21.7867C23.6592 21.8053 24.244 22.3967 24.2352 23.1293C24.2383 23.6554 23.6454 24.2029 23.4591 24.3567C21.3236 26.1197 18.3649 26.4896 15.8627 25.3065C13.3605 24.1234 11.764 21.5996 11.7637 18.8267Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarWhiteCLogo);
export default __webpack_public_path__ + "static/media/sidebar-white-c-logo.b931b21ba2a8a3f8df4b5ee5752648d8.svg";
export { ForwardRef as ReactComponent };